"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_backspace__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "backspace_dark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.88,86.88,45.21,45.39A11.6,11.6,0,0,1,55,40H160.74a15.5,15.5,0,0,1,15.51,15.51v80.85a15.5,15.5,0,0,1-15.51,15.5H55a11.62,11.62,0,0,1-9.8-5.38L18.88,105A16.89,16.89,0,0,1,18.88,86.88Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.74,149.93H55a11.6,11.6,0,0,1-9.8-5.38l-26.33-41.5A16.77,16.77,0,0,1,16.28,95a16.91,16.91,0,0,0,2.6,10l26.33,41.49a11.6,11.6,0,0,0,9.8,5.38H160.74a15.5,15.5,0,0,0,15.51-15.5v-1.93A15.5,15.5,0,0,1,160.74,149.93Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 85.33,
    y1: 71.5,
    x2: 133.83,
    y2: 120,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.05369407146173px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.83,
    y1: 71.5,
    x2: 85.33,
    y2: 120,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.05369407146173px"
    }
  })));
}

var _default = ic_backspace__dark;
exports.default = _default;